export default __webpack_public_path__ + "static/media/JobSix7.35194d6c.jpg";